module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v("iRidium BYOD " + _vm._s(this.$store.state.pkg.Version))]), _vm._v(" "), _c('h3', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v(_vm._s(_vm.$t('index.reg_center')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.$auth.check()) ? _c('section', {
    staticClass: "section has-text-centered"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "button is-info is-large"
  }, [_vm._v(_vm._s(_vm.$t('index.login')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('section', {
    staticClass: "section has-text-centered"
  }, [_c('a', {
    staticClass: "button is-large",
    attrs: {
      "href": "/#/administration_manager"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.go_to_object_adm')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    attrs: {
      "href": "/#/reception_manager"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.go_to_reception_adm')))])]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-full-mobile is-half-desktop is-offset-one-quarter-desktop "
  }, [_c('h2', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v(_vm._s(_vm.$t('index.profile.user_info')))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.login'),
      "type": {
        'is-danger': !_vm.data.login
      },
      "message": ( _obj = {}, _obj[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.login, _obj )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.data.login),
      callback: function($$v) {
        _vm.$set(_vm.data, "login", $$v)
      },
      expression: "data.login"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.name'),
      "type": {
        'is-danger': !_vm.data.name
      },
      "message": ( _obj$1 = {}, _obj$1[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.name, _obj$1 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.lastname'),
      "type": {
        'is-danger': !_vm.data.lastname
      },
      "message": ( _obj$2 = {}, _obj$2[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.lastname, _obj$2 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.lastname),
      callback: function($$v) {
        _vm.$set(_vm.data, "lastname", $$v)
      },
      expression: "data.lastname"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.save_profile')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.change_password')))])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isChangePassword,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isChangePassword = $event
      }
    }
  }, [_c('changepassword')], 1)], 1) : _vm._e()])
  var _obj;
  var _obj$1;
  var _obj$2;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89770e90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 318
// module chunks = 2